import { useEffect, useRef } from "react";

import NoteItem from "components/NoteItem";
import EmailDigestEntry from "components/LogItem/EmailDigestEntry";
import { resolveEventEntry } from "components/LogItem/eventEntry";
import LogEntryCard from "components/LogItem/LogEntryCard";

// A note entry the listing did not collapse into a deletion: the note still
// exists, so the log shows the note itself rather than a record of the event.
const NOTE_CARD_ACTIONS = ["activity_log.created", "activity_log.modified"];

const LogItem = ({
  item,
  modelType,
  modelId,
  activeItem,
  categories,
  dispositions,
  refreshLog,
  slug,
  feedFilters,
}) => {
  const ref = useRef();
  useEffect(() => {
    if (activeItem && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [activeItem]);

  // Rendered as the same card the notes list uses, so a note reads the same
  // wherever it appears. A deletion keeps the event framing instead: there is
  // no note left to act on.
  if (NOTE_CARD_ACTIONS.includes(item.action) && item.note) {
    return (
      <NoteItem
        ref={ref}
        className={activeItem ? "highlight" : undefined}
        // The entry computes source_name at its top level; the shared card
        // reads it off the note, so pass it down onto the note object.
        note={{ ...item.note, source_name: item.source_name }}
        categories={categories ?? []}
        attachments={item.note_attachments}
        versions={item.note_versions}
        onChange={refreshLog}
        slug={slug}
        modelId={modelId}
      />
    );
  }

  if (item.digest) {
    return (
      <EmailDigestEntry
        ref={ref}
        item={item}
        modelType={modelType}
        modelId={modelId}
        activeItem={activeItem}
        feedFilters={feedFilters}
        dispositions={dispositions}
        refreshLog={refreshLog}
      />
    );
  }

  return (
    <LogEntryCard
      ref={ref}
      item={item}
      entry={resolveEventEntry(item)}
      modelType={modelType}
      modelId={modelId}
      activeItem={activeItem}
      dispositions={dispositions}
      refreshLog={refreshLog}
    />
  );
};

export default LogItem;
